<template>
    <div id="pt482" class="pt482" v-if="(pt482Init.kokyakuKbn == 'B' && pt482Init.tokuisakiFlg == 1) || (pt482Init.kokyakuKbn == 'C' && pt482Init.kokyakuFlg == 1)">
        <div class="pt482Main">
            <div class="itemTitle">
                <h3>{{$t('pt482.labels.title')}}</h3>
            </div>
            <div class="ranking">
                <div class="rankInfo">
                    <div class="img">
                        <img src="../img/icons/demo/rank.png">
                    </div>
                    <div class="rank">
                        <div class="rankNameNow">{{$t('pt482.labels.rankNow')}}{{pt482Init.rankList[0].KOKYAKU_RANK_KBN_NM}}</div>
                        <template v-if="pt482Init.rankList[0].COLLECT_NG_FLG == 0">
                            <div class="rankInformation" v-if="pt482Init.rankList[0].RANK_FLG == 0 && (pt482Init.rankList[0].CURRENT_RANK_FLG == 1 || pt482Init.rankList[0].NEXT_RANK_FLG == 1)">
                                <div v-if="pt482Init.rankList[0].NEXT_MONEY != 0 && pt482Init.rankList[0].NEXT_RANK_FLG == '1'">
                                    {{pt482Init.rankList[0].RANK_LAST_DAY}}{{$t("pt482.labels.viewUpRank[0]")}}{{formatPrice(pt482Init.rankList[0].NEXT_MONEY)}}{{$t("pt482.labels.viewUpRank[1]")}}{{pt482Init.rankList[0].NEXT_KOKYAKU_RANK_KBN_NM}}{{$t("pt482.labels.viewUpRank[2]")}}
                                </div>
                                <div v-else-if="pt482Init.rankList[0].NEXT_RANK_FLG == '1' && pt482Init.rankList[0].CURRENT_RANK_FLG == '1'">
                                    {{$t("pt482.labels.viewNextRank[0]")}}{{pt482Init.rankList[0].NEXT_KOKYAKU_RANK_KBN_NM}}{{$t("pt482.labels.viewNextRank[1]")}}
                                </div>
                                <div v-else>
                                    {{$t("pt482.labels.viewNextRank[0]")}}{{pt482Init.rankList[0].KOKYAKU_RANK_KBN_NM}}{{$t("pt482.labels.viewNextRank[1]")}}
                                </div>
                            </div>
                            <div class="rankInformation" v-if="pt482Init.rankList[0].RANK_FLG == 1">
                                <div v-if="pt482Init.rankList[0].CURRENT_MONEY != 0 && pt482Init.rankList[0].CURRENT_RANK_FLG != 0">
                                    {{pt482Init.rankList[0].RANK_LAST_DAY}}{{$t("pt482.labels.viewKeepRank[0]")}}{{formatPrice(pt482Init.rankList[0].CURRENT_MONEY)}}{{$t("pt482.labels.viewKeepRank[1]")}}{{pt482Init.rankList[0].KOKYAKU_RANK_KBN_NM}}{{$t("pt482.labels.viewKeepRank[2]")}}
                                </div>
                                <div v-if="pt482Init.rankList[0].NEXT_MONEY != 0 && (pt482Init.rankList[0].NEXT_RANK_FLG == '1')">
                                    {{pt482Init.rankList[0].RANK_LAST_DAY}}{{$t("pt482.labels.viewUpRank[0]")}}{{formatPrice(pt482Init.rankList[0].NEXT_MONEY)}}{{$t("pt482.labels.viewUpRank[1]")}}{{pt482Init.rankList[0].NEXT_KOKYAKU_RANK_KBN_NM}}{{$t("pt482.labels.viewUpRank[2]")}}
                                </div>
                            </div>
                            <div class="rankInformation" v-else-if="pt482Init.rankList[0].RANK_FLG == 2 && pt482Init.rankList[0].NEXT_RANK_FLG == 1">
                                <div v-if="pt482Init.rankList[0].NEXT_MONEY > 0 && pt482Init.rankList[0].CURRENT_RANK_FLG == '1'">
                                    {{pt482Init.rankList[0].RANK_LAST_DAY}}{{$t("pt482.labels.viewUpRank[0]")}}{{formatPrice(pt482Init.rankList[0].NEXT_MONEY)}}{{$t("pt482.labels.viewUpRank[1]")}}{{pt482Init.rankList[0].NEXT_KOKYAKU_RANK_KBN_NM}}{{$t("pt482.labels.viewUpRank[2]")}}
                                </div>
                                <div v-else>
                                    {{$t("pt482.labels.viewNextRank[0]")}}{{pt482Init.rankList[0].NEXT_KOKYAKU_RANK_KBN_NM}}{{$t("pt482.labels.viewNextRank[1]")}}
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="btnSyohinAdd" v-if="pt482Init.pageNo == 22">
                    <input class="button" type="submit" @click="backStep()" :value="$t('pt482.buttons.shohinAdd')">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import DataTable from 'components/Datatable';
import common from 'assets/js/common';
import BackButton from 'components/BackButton';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import Message from 'components/MessageEcSite';
import Loading from 'vue-loading-overlay';
import InputCheck from 'components/InputCheck.vue';
import DownloadFile from 'components/DownloadFile';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';

export default {
    /*
    * Name of component
    */
    name: "PT482MemberRankDisplayParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /*
    * Declare components
    */
    components: {
        DataTable,
        BackButton,
        Message: Message,
        Loading,
        InputCheck,
        DownloadFile,
        AlertConfirm,
        InputNumber,
        Breadcrumb
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            PT482_PART: "pt482",
            listMessValid:[],
            mapMessValid:[],
            showFlg: false,
            isModalShow: false,
            isLoading: false,
            isDisplaySortFlg: true,
            pt482ReqModel: {},
            pt482Init: {
            },
            SiteConstants: SiteConstants
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            if(_this.ptInitData.isLogin == false){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
            }else{
                _this.pt482Init = _this.ptInitData;
            }
        } else {
             // eslint-disable-next-line
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT482 + _this.$UrlConstants.DO_INIT).then(function(response) {
                if(response.data.isLogin == false || response.data.isLogin == undefined){
                    _this.$router.push({name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                }else{
                    _this.pt482Init = response.data;
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    /*
    * Methods
    */
    methods: {
        backStep: function(){
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 1}});
        },
        /**
         * format number value to currency value
         * @param {number} value, number to format
         */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
    },
    created(){
        this.queryData = this.$route.query;
        this.paramsData = this.$route.params;
    },
}
</script>
